const PriorityDisplay = ({ priority }) => {

  return (
    <div className="priority-display">
      <div className="star-container">
        <h3 style={{color: priority >=1 ? '#FFFF0F' : ''}}>✭</h3>
        <h3 style={{color: priority >=2 ? '#FFFF0F' : ''}}>✭</h3>
        <h3 style={{color: priority >=3 ? '#FFFF0F' : ''}}>✭</h3>
        <h3 style={{color: priority >=4 ? '#FFFF0F' : ''}}>✭</h3>
        <h3 style={{color: priority >=5 ? '#FFFF0F' : ''}}>✭</h3>
      </div>
    </div>
  )
}

export default PriorityDisplay